var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative w-screen h-screen",attrs:{"id":"app"}},[_c('NavBar'),_c('Hero'),_c('AboutUs'),_c('Services'),_c('ContactForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }